import { render, staticRenderFns } from "./SampleMenu.vue?vue&type=template&id=57ddca14&scoped=true&"
import script from "./SampleMenu.vue?vue&type=script&lang=js&"
export * from "./SampleMenu.vue?vue&type=script&lang=js&"
import style0 from "./SampleMenu.vue?vue&type=style&index=0&id=57ddca14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ddca14",
  null
  
)

export default component.exports